export const ACTION_PREFIX = 'SHIFT_PAY_SUMMARY';
export const PARTITION = 'shiftPaySummary';

export const actionTypes = {
  SET_INTENT_ID: 'SET_INTENT_ID',
  SET_CHECKOUT_ID: 'SET_CHECKOUT_ID',
};
